export default "__VITE_ASSET__CgItqoXz__"